import { useMemo, useState } from 'react';
import { WisoryInput, WisorySelect } from 'components/Inputs';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';

type Props = {
  value?: string;
  onChange: (v?: string) => void;
  autoFocus?: boolean;
};

export const ReasonDropdown = ({ value, autoFocus, onChange }: Props) => {
  const { t } = useTranslation();
  const otherOption = t('REACT_BOOKING_FRONTEND.goalDropdown.otherOption');
  const options = useMemo(() => {
    return t('REACT_BOOKING_FRONTEND.goalDropdown.options').split(',');
  }, [t]);
  const [internalValue, setInternalValue] = useState(value);
  const [isOtherReasonShow, setIsOtherReasonShow] = useState(value ? !options.includes(value) : false);

  return (
    <>
      <div className="flex mb-4">
        <WisorySelect
          autoFocus={autoFocus}
          className={clsx({
            'w-1/2': isOtherReasonShow,
            'w-full': !isOtherReasonShow,
          })}
          title="Others"
          value={isOtherReasonShow ? otherOption : internalValue}
          onChange={(e) => {
            const selected = e.target.value;

            if (selected !== otherOption) {
              setIsOtherReasonShow(false);
              setInternalValue(selected);
              onChange(selected);
            } else {
              setIsOtherReasonShow(true);
              setInternalValue(undefined);
              onChange(undefined);
            }
          }}
        >
          <option value="">{t('REACT_BOOKING_FRONTEND.goalDropdown.emptyOption')}</option>
          {options.map((item) => (
            <option key={item} value={item} className="text-black">
              {item}
            </option>
          ))}
        </WisorySelect>
        {isOtherReasonShow && (
          <WisoryInput
            required
            maxLength={120}
            autoFocus={!isMobile}
            className="ml-4 w-1/2"
            value={internalValue}
            onChange={(e) => {
              setInternalValue(e.target.value);
              onChange(e.target.value);
            }}
          />
        )}
      </div>
    </>
  );
};
